var _defs, _rect, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGameBgPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 900,
    viewBox: "0 0 1600 900",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f5f9ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#d7e9cd"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 130,
    r: 150,
    fill: "#c8dfb6",
    opacity: 0.45
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1450,
    cy: 760,
    r: 170,
    fill: "#bdd9a7",
    opacity: 0.45
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 900,
    cy: 90,
    r: 110,
    fill: "#dbeacc",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameBgPattern);
export default __webpack_public_path__ + "static/media/game-bg-pattern.ecf5bc662da0079e4ef53a134cca7223.svg";
export { ForwardRef as ReactComponent };